<template>
  <div class="doctor-course big">
    <div class="page_title">医生教程</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="between" style="margin-bottom: 20px">
          <div class="search-box">
            <div class="item">
              <span>标题</span>
              <div class="item-content">
                <el-input
                  v-model="searchForm.title"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="请输入"
                ></el-input>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
            </div>
          </div>

          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1510') : false
            "
            @click="addCourse"
            >添加教程</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="doctorTableRef"
            class="doctor-table"
            v-loading="tableLoading"
            :data="doctorTableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              align="center"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'update_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'read_num'">
                  <el-link
                    type="primary"
                    @click="readDetailsBtn(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1745')
                        : false
                    "
                    >{{ scope.row.read_num }}
                  </el-link>
                </div>
                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | stateText }}
                </div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column label="排序" width="200px" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置顶"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row.vt_id, 1)"
                    size="medium"
                    type="text"
                    icon="el-icon-upload2"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1513')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置底"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row.vt_id, 2)"
                    size="medium"
                    type="text"
                    icon="el-icon-download"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1513')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="上移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row.vt_id, 3)"
                    size="medium"
                    type="text"
                    icon="el-icon-top"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1513')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="下移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row.vt_id, 4)"
                    size="medium"
                    type="text"
                    icon="el-icon-bottom"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1513')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="140px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 1"
                  @click="infoEdit(scope.row.vt_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1511')
                      : false
                  "
                  size="medium"
                  >编辑</el-button
                >

                <el-button
                  v-if="scope.row.status == 2"
                  @click="infoDetail(scope.row.vt_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1515')
                      : false
                  "
                  size="medium"
                  >详情</el-button
                >

                <el-button
                  v-if="scope.row.status == 1"
                  @click="changeStatus(scope.row.vt_id, 2)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1514')
                      : false
                  "
                  size="medium"
                  >发布</el-button
                >

                <el-button
                  v-if="scope.row.status == 2"
                  @click="changeStatus(scope.row.vt_id, 1)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1514')
                      : false
                  "
                  size="medium"
                  >下架</el-button
                >

                <el-button
                  v-if="scope.row.status == 1"
                  @click="delBtn(scope.row.vt_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1516')
                      : false
                  "
                  size="medium"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>

    <!-- 阅读详情 -->
    <el-dialog title="详情" :visible.sync="readDetailsVisible" width="1300px">
      <div style="padding: 20px 20px 0">
        <div class="search-box">
          <!-- 标题 -->
          <div class="item">
            <span>标题</span>
            <div class="item-content">
              <el-input
                v-model="readDetailsForm.title"
                size="small"
                clearable
                placeholder="请输入"
                @change="changeReadDetailsForm"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span style="margin-left: 10px">医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="readDetailsForm.phone"
                size="small"
                clearable
                placeholder="请输入"
                @change="changeReadDetailsForm"
              ></el-input>
            </div>
          </div>

          <!-- 阅读时间 -->
          <div class="item">
            <span style="margin-left: 10px">阅读时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="readDetailsForm.read_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="changeReadDetailsForm"
              >
              </el-date-picker>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="tutorialReadLogList"
              >查询</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="tutorialReadLogExport"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1746') : false
              "
              >导出</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="readDetailsTableLoading"
          :data="readDetailsTableData"
          ref="readDetailsTableRef"
          height="530px"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in readDetailsTableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>

              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="readDetailsTotalNum > 0"
        :total="readDetailsTotalNum"
        :page.sync="readDetailsPagination.page"
        :limit.sync="readDetailsPagination.pageNumber"
        @pagination="tutorialReadLogList"
      />
    </el-dialog>
  </div>
</template>
<script>
import imgtext from "../../../api/imgtext";
import Pagination from "../../../components/Pagination/index";
import dayjs from "dayjs";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableHeader: [
        {
          label: "标题",
          prop: "title",
          width: "auto",
        },
        {
          label: "编辑时间",
          prop: "update_time",
          width: "auto",
        },
        {
          label: "阅读量",
          prop: "read_num",
          width: "80px",
        },
        {
          label: "状态",
          prop: "status",
          width: "200px",
        },
      ],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      doctorTableData: [],
      searchForm: {
        title: "",
      },
      readDetailsForm: {
        title: "",
        phone: "",
        read_time: "",
      },
      readDetailsVisible: false,
      readDetailsTableLoading: false,
      readDetailsTotalNum: 0,
      readDetailsPagination: {
        page: 1,
        pageNumber: 10,
      },
      readDetailsTableHeader: [
        {
          label: "标题",
          prop: "title",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "阅读医生",
          prop: "doctor_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "阅读时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: "right",
        },
      ],
      readDetailsTableData: [],
    };
  },
  filters: {
    stateText(val) {
      switch (val) {
        case 1:
          return "未发布";
        case 2:
          return "已发布";
      }
    },
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取报表列表
    getList() {
      this.tableLoading = true;
      let params = Object.assign({}, this.searchForm, this.pagination);
      imgtext
        .doctortutorialGetList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.totalNum = data.total;
            this.doctorTableData = data.list;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    addCourse() {
      this.$router.push({
        path: "/home/imgtext/doctorCourseDetails",
        query: {
          vt_id: -99,
        },
      });
    },
    // 发布/下架
    changeStatus(vt_id, status) {
      this.$confirm(
        `确认${status === 1 ? "下架" : "发布"}当前教程吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(() => {
        imgtext.doctortutoriaOnoff({ vt_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success(`${status === 1 ? "下架成功" : "发布成功"}`);
            this.getList();
          }
        });
      });
    },
    // 排序
    updateSort(vt_id, op_type) {
      imgtext.doctortutorialSetSort({ vt_id, op_type }).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("排序成功");
          this.getList();
        }
      });
    },
    // 删除
    delBtn(vt_id) {
      this.$confirm("确认删除当前教程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        imgtext.doctortutoriaDelete({ vt_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
    infoDetail(vt_id) {
      this.$router.push({
        path: "/home/imgtext/doctorCourseDetails",
        query: {
          vt_id,
          is_look: 1,
        },
      });
    },
    infoEdit(vt_id) {
      this.$router.push({
        path: "/home/imgtext/doctorCourseDetails",
        query: {
          vt_id,
        },
      });
    },
    // 阅读详情
    readDetailsBtn(row) {
      let { vt_id, title } = row;
      this.readDetailsForm["vt_id"] = vt_id;
      this.readDetailsForm["title"] = title;
      this.readDetailsForm["phone"] = "";
      // 近三个月
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.readDetailsForm["read_time"] = [
        dayjs(start).format("YYYY-MM-DD"),
        dayjs(end).format("YYYY-MM-DD"),
      ];
      this.readDetailsVisible = true;
      this.tutorialReadLogList();
    },
    // 阅读详情列表
    changeReadDetailsForm() {
      this.readDetailsForm["vt_id"] = "";
      this.readDetailsPagination.page = 1;
    },
    tutorialReadLogList() {
      this.readDetailsTableLoading = true;
      let params = Object.assign(
        {},
        this.readDetailsPagination,
        this.readDetailsForm
      );
      params = _.omit(params, ["read_time"]);
      let read_time = this.readDetailsForm.read_time;
      params.start_time = read_time ? read_time[0] : "";
      params.end_time = read_time ? read_time[1] : "";
      imgtext
        .tutorialReadLogList(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.readDetailsTableData = data.list;
            this.readDetailsTotalNum = data.total;
            this.$nextTick(() => {
              if (
                this.$refs.readDetailsTableRef &&
                this.$refs.readDetailsTableRef.doLayout
              ) {
                this.$refs.readDetailsTableRef.doLayout();
              }
            });
          }
          this.readDetailsTableLoading = false;
        })
        .catch(() => (this.readDetailsTableLoading = false));
    },
    // 教程阅读列表导出
    tutorialReadLogExport() {
      let params = Object.assign({}, this.readDetailsForm);
      params = _.omit(params, ["read_time"]);
      let read_time = this.readDetailsForm.read_time;
      params.start_time = read_time ? read_time[0] : "";
      params.end_time = read_time ? read_time[1] : "";
      const loading = this.$loading();
      imgtext
        .tutorialReadLogExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss">
.doctor-course {
  .container {
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: calc(100vh - 140px);
    padding: 20px;
    text-align: left;
  }
  .pagination-container {
    display: flex;
    justify-content: center;
  }
}
.search-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      margin-right: 4px;
      text-align: right;
      white-space: nowrap;
      box-sizing: border-box;
    }
  }
  .item-content {
    // width: 100%;
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>
